import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
export interface IAlertProps {
  showModal: boolean;
  message: string;
  closeAlert: Function;
}
class AlertMessage extends React.Component<IAlertProps> {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Modal id="modalMessage" isOpen={this.props.showModal} backdrop="static" centered={window.location === window.parent.location}>
          <ModalBody>
            <div style={{ textAlign: 'center' }}>
              <label>{this.props.message}</label>
            </div>
            <div>
              <Button
                className="btn-register"
                style={{ width: '30%', marginTop: '10px', marginLeft: 'auto', marginRight: 'auto' }}
                block
                onClick={this.props.closeAlert}
              >
                Xác nhận
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default AlertMessage;
